module.exports = __webpack_public_path__ + "assets/img/shareholders.7e5c59b2.png";